import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

// generic component imports
import ReportingGC from '../../components/ReportingGC/ReportingGC';

interface Props {}

const Reporting: React.FC<Props> = () => {
  const [reportTypes] = useState([
    { name: 'CventAttendeesReport', label: 'Cvent Attendees Bulk Import Report' },
    { name: 'DelegateRawData', label: 'Delegate/Alternate Raw Data' },
    { name: 'AttendeesReport', label: 'Attendees' },
    { name: 'AttendeeByDay', label: 'Attendees Registered By Day' },
    {
      name: 'AttendeeByDateRange',
      label: 'Attendees Registered by Date Range',
    },
    { name: 'CommitteesSummary', label: 'Committees Summary' },
    { name: 'AffiliateSummary', label: 'Affiliate Summary' },
    { name: 'RegisteredByAffiliate', label: 'Registered By Affiliate' },
  ]);

  return (
    <Grid container size={{ xs: 12 }}>
      <Grid size={{ xs: 12 }}>
        <h2>Reporting</h2>
      </Grid>
      <Grid size={{ xs: 12 }} className="pt-4">
        <ReportingGC reportTypes={reportTypes} />
      </Grid>
    </Grid>
  );
};

export default Reporting;
